import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IReqBlikSmsSend,
  IReqBlikSmsVerification,
  IResBlikSms,
} from './blik-sms.interface';

@Injectable({
  providedIn: 'root',
})
export class BlikSmsService {
  private readonly sendUrl = '/api/v2/blik-sms/send';
  private readonly verificationUrl = '/api/v2/blik-sms/verification';

  constructor(protected http: HttpClient) {}

  send(request: IReqBlikSmsSend): Observable<IResBlikSms> {
    return this.http.post<IResBlikSms>(this.sendUrl, request);
  }

  verification(request: IReqBlikSmsVerification): Observable<IResBlikSms> {
    return this.http.post<IResBlikSms>(this.verificationUrl, request);
  }
}
